import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// --- PrimeNG ---
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';

// --- Components ---
import { PlanTooltipModule } from '@components/info-messages/plan-tooltip/plan-tooltip.module';
import { HeaderComponent } from './header.component';
import { CartDialogModule } from '../dialogs/cart-dialog/cart-dialog.module';
import { FavoritesDialogModule } from '../dialogs/favorites-dialog/favorites-dialog.module';

// --- Overlay Panels ---
import { AutocompleteOverlayPanelModule } from '@components/overlay-panels/autocomplete-overlay-panel/autocomplete-overlay-panel.module';
import { UnreadOrderMsgsPanelModule } from '../overlay-panels/unread-order-msgs-panel/unread-order-msgs-panel.module';
import { SearchBoxModule } from '@components/search-box/search-box.module';

// --- Directives ---
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
	declarations: [HeaderComponent],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,

		// --- PrimeNG ---
		AvatarModule,
		ButtonModule,
		MenuModule,
		OverlayPanelModule,
		TooltipModule,
		MenubarModule,
		DividerModule,
		BadgeModule,
		MegaMenuModule,

		// --- Overlay Panels ---
		UnreadOrderMsgsPanelModule,
		SearchBoxModule,
		AutocompleteOverlayPanelModule,
		PlanTooltipModule,

		CartDialogModule,
		FavoritesDialogModule,
		DirectivesModule,
	],
	exports: [HeaderComponent],
	providers: [],
})
export class HeaderModule {}
